import { isAddress } from "ethers";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { approveForTransferNodes, transferNodes } from "../../uniswap/utils";
import {
  BootstrapDialog,
  CustomBackdrop,
} from "../newBuyNode/components/NodeModal";
import ReferralInput from "../newBuyNode/components/ReferralInput";
import NodeToTransfer from "./NodeToTransfer";
import TransferModalButton from "./components/TransferModalButton";
import { QRScanner } from "./components/QRScanner";
import { toast, Toaster } from "react-hot-toast";
import CloseModalButton from '../../components/Modal/components/CloseModalButton';
import { getEthersSigner } from '../../utils/wagmi.utils';

const TransferNodeModal = ({ openModal, closeModal, nodes }) => {
  const navigate = useNavigate();
  const [referralAddress, setReferralAddress] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [selectedNode, setSelectedNode] = useState("");
  const [approve, setApprove] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [startX, setStartX] = useState(false);
  const [scrollLeft, setScrollLeft] = useState(0);

  const [isCameraOpen, setIsCameraOpen] = useState(false);

  const itemRef = useRef(null);

  const onChangeReferralAddress = async (value) => {
    setReferralAddress(value);
  };

  const handleApprove = async (address) => {
    try {
      if (!isApproved && !isLoading) {
				const signer = await getEthersSigner()
        setIsLoading(true);
        const approval = await approveForTransferNodes(
          selectedNode,
          address,
					signer
        );
        setIsLoading(false);
        if (approval) {
          setIsApproved(true);
          setApprove(true);
        }
      }
    } catch (error) {
      console.log("handleApprove error", error);
    }
  };

  const handleProceed = async (address) => {
    try {
      if (isAddress(address)) {
				const signer = await getEthersSigner()
        const tx = await transferNodes(selectedNode, address, signer);
        if (tx) {
          navigate("/node", { state: { quantity } });
        }
      }
    } catch (error) {
      console.error("handleTransfer error", error);
    }
  };

  const handleReferralInputChange = (event) => {
    onChangeReferralAddress(event.target.value);
  };

  const handleMouseDown = (e) => {
    setIsMouseDown(true);
    setStartX(e.pageX - -itemRef.current.offsetLeft);
    setScrollLeft(itemRef.current.scrollLeft);
  };
  const handleMouseLeave = (e) => {
    setIsMouseDown(false);
  };
  const handleMouseUp = () => {
    setIsMouseDown(false);
  };
  const handleMouseMove = (e) => {
    if (!isMouseDown) {
      return;
    }
    e.preventDefault();
    const x = e.pageX - itemRef.current.offsetLeft;
    const walk = (x - startX) * 1;
    itemRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <BootstrapDialog
      open={openModal}
      onClose={closeModal}
      slots={{ backdrop: CustomBackdrop }}
    >
      <div className="font-inter max-w-140 bg-white shadow-smallShadow rounded-3xl overflow-x-hidden dark:bg-[#1D1C2D]">
        <div className="flex justify-between items-center md:items-start py-6 px-4 md:px-8 border-b border-lightGrayBlue dark:border-darkSlateBlue w-full">
          <h3 className="font-bold leading-9 text-xl md:text-2xl text-black dark:text-white">
            Transfer Nodes
          </h3>
          <CloseModalButton closeModal={closeModal} />
        </div>

        <div className="pt-3 border-b border-lightGrayBlue dark:border-darkSlateBlue">
          <h4 className="font-medium text-base leading-6 text-black dark:text-white pl-4 md:pl-8">
            Select one or more nodes
          </h4>
          <div
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            ref={itemRef}
            className="grid grid-flow-col-dense md:w-140 auto-cols-[242px] hide-scrollbar scroll-smooth snap-x gap-3 overflow-x-auto pb-4 pt-3 px-4 md:px-8"
          >
            {nodes.map((eachNode) => (
              <NodeToTransfer
                key={eachNode.nodeId}
                nodeName={eachNode.nodeId}
                setCurrentNode={setSelectedNode}
                currentNode={selectedNode}
              />
            ))}
          </div>
        </div>
        <div>
          <ReferralInput
            referralAddress={referralAddress}
            handleReferralInputChange={handleReferralInputChange}
            label={"Receiver Address"}
            placeholderValue={"Enter or scan receiver address"}
            setIsCameraOpen={setIsCameraOpen}
            isTransfer={true}
          />

          {isCameraOpen && (
            <QRScanner
              setInputValue={setReferralAddress}
              setIsCameraOpen={setIsCameraOpen}
              isCameraOpen={isCameraOpen}
              searchValue={referralAddress}
              setScannerError={() => toast.error("QR Scanner error!")}
            />
          )}
          <div className="px-4 md:px-8 pt-4 pb-4 md:pt-6 md:pb-6">
            <TransferModalButton
              handleApprove={handleApprove}
              referralAddress={referralAddress}
              approve={approve}
              isLoading={isLoading}
              handleProceed={handleProceed}
							disabled={isLoading || !selectedNode}
            />
          </div>
        </div>
      </div>
      <Toaster />
    </BootstrapDialog>
  );
};

export default TransferNodeModal;
